<template>
  <div>
    <div class="mb10 flex flex-between item-center bgColor p10">
      <div>
        <el-radio-group
          v-model="searchCondition.status"
          size="small"
          @change="switchTab"
        >
          <el-radio-button label="goods">商品明细</el-radio-button>
          <el-radio-button label="tiXian">申报明细</el-radio-button>
          <el-radio-button label="menDian">门店统计</el-radio-button>
          <el-radio-button label="daoGou">导购统计</el-radio-button>
          <el-radio-button label="mingxi">品牌明细</el-radio-button>
          <el-radio-button label="storeShare">分成明细</el-radio-button>

          <!-- <el-radio-button label="jiLu">拦截记录</el-radio-button> -->
        </el-radio-group>
      </div>
      <div>
        当前供货商: <span class="primary">{{ storeNames }}</span>
      </div>
    </div>
    <div
      class="table-panel flex flex-end item-center bgColor"
      style="padding: 0 10px"
    >
      <!-- <el-cascader
        clearable
        class="mr10"
        ref="cascader"
        v-model="searchCondition.storeOrShopIds"
        :props="props"
        filterable
        :show-all-levels="false"
        size="small"
        placeholder="请选择商户"
      ></el-cascader> -->

      <div style="width: 160px; overflow: hidden">
        <el-select
          style="width: 160px"
          v-if="
            searchCondition.storeOrShopIds &&
            searchCondition.storeOrShopIds.length > 0
          "
          v-model="selectedOptions"
          size="small"
          multiple
          placeholder="所选门店"
        >
          <el-option
            v-for="item in allOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="item.disabled"
          >
          </el-option>
        </el-select>
      </div>
      <div
        style="
          color: #e50065;
          font-size: 15px;
          font-weight: 500;
          cursor: pointer;
          margin: 0 20px;
        "
        v-if="
          searchCondition.storeOrShopIds &&
          searchCondition.storeOrShopIds.length > 0
        "
        @click="deleteShops"
      >
        清空
      </div>
      <!-- <el-button v-else type="primary" size="small" class="mr10" @click="openVisible"
          >选择门店</el-button
        > -->
      <div
        v-else
        style="
          display: flex;
          flex-flow: row nowrap;
          justify-content: flex-start;
          align-items: center;
          width: 80px;
          cursor: pointer;
        "
        @click="openVisible"
      >
        <img
          style="width: 16px; height: 16px; margin-right: 6px"
          class="avatar"
          src="@/assets/shaixuan.png"
          alt=""
        />
        <div style="font-size: 14px; color: #909399; margin-right: 10px">
          筛选
        </div>
      </div>
      <el-dialog
        :close-on-click-modal="false"
        title="选择门店"
        width="1600px"
        :before-close="qx"
        :visible.sync="storeVisible"
      >
        <div class="flex">
          <div class="mr10" style="width: 600px">
            <div class="table-panel flex flex-between">
              <div class="fr" style="width: 100%">
                <el-button
                  class="fr"
                  style="margin-right: 10px"
                  type="primary"
                  size="small"
                  @click="storeSearch"
                  >查询</el-button
                >
                <el-input
                  clearable
                  v-model.trim="storesNames"
                  placeholder="请输入商户"
                  size="small"
                  class="ipt mr10 fr"
                >
                </el-input>
              </div>
            </div>
            <div class="table-panel">
              <div class="tables">
                <el-table
                  stripe
                  ref="roleTable"
                  :data="storeBasucList.records"
                  style="width: 100%"
                  id="table"
                  @row-click="tableSelect"
                  size="small"
                  border
                  max-height="500"
                  @selection-change="handleSelectionChange"
                >
                  <el-table-column
                    type="selection"
                    header-align="center"
                    align="center"
                    width="50"
                  >
                  </el-table-column>
                  <el-table-column
                    type="index"
                    label="序号"
                    align="center"
                    :index="
                      (index) =>
                        index + (storeCurrentPage - 1) * storePageSize + 1
                    "
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="storeName"
                    label="商户"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="shopCount"
                    width="90"
                    label="门店数"
                  ></el-table-column>
                </el-table>
              </div>
              <div class="hm-pagination">
                <el-pagination
                  background
                  small
                  :pager-count="5"
                  :total="storeBasucList.total"
                  @current-change="storePaging"
                  :page-size="storePageSize"
                  @size-change="storeHandleSizeChange"
                  layout="total,sizes,  prev, pager, next, jumper"
                  :current-page="storeCurrentPage"
                ></el-pagination>
              </div>
            </div>
          </div>
          <div class="mar10 seach_checked">
            <el-button
              class="btn"
              type="primary"
              size="small"
              @click="searchShop"
              >查询勾选商户门店</el-button
            >
          </div>
          <div class="mr10 w60" style="width: 800px">
            <div class="table-panel flex flex-between">
              <div class="fr">
                <el-input
                  clearable
                  v-model.trim="shopName"
                  placeholder="请输入门店名称"
                  size="small"
                  class="ipt mr10"
                ></el-input>
                <el-button type="primary" size="small" @click="shopSearch"
                  >查询</el-button
                >
              </div>
            </div>
            <div class="table-panel">
              <div class="table">
                <el-table
                  stripe
                  ref="rightData"
                  :data="notRelShopList.records"
                  style="width: 100%"
                  id="table"
                  size="small"
                  @row-click="rightTableSelect"
                  @selection-change="getShopChecked"
                  border
                  max-height="500"
                >
                  <el-table-column type="selection"></el-table-column>
                  <el-table-column
                    type="index"
                    label="序号"
                    :index="
                      (index) =>
                        index + (shopCurrentPage - 1) * shopPageSize + 1
                    "
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="storeName"
                    label="商户"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    width="150"
                    prop="shopName"
                    label="门店名称"
                  >
                    <template slot-scope="scope">
                      <div class="flex item-center">
                        <span>{{ scope.row.shopName }}</span>
                        <span
                          v-if="scope.row.shopMonthlyStatementFlag"
                          class="monthlyStatement-wrapper"
                          >月结</span
                        >
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    label="所在省/市/区"
                    prop="citys"
                  >
                    <template slot-scope="scope">
                      <div>
                        {{ scope.row.provinceName }}{{ scope.row.cityName
                        }}{{ scope.row.districtName }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    label="详细地址"
                    prop="shopAddress"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    label="组织机构代码"
                    prop="orgCode"
                  >
                  </el-table-column>
                </el-table>
              </div>
              <div class="hm-pagination">
                <el-pagination
                  small
                  background
                  :total="notRelShopList.total"
                  @current-change="shopPaging"
                  :page-size="shopPageSize"
                  @size-change="shopHandleSizeChange"
                  layout="total,sizes, prev, pager, next, jumper"
                  :current-page="shopCurrentPage"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-wrapper flex flex-center">
          <el-button size="small" type="primary" @click="submitAllStore()"
            >确 定</el-button
          >
          <el-button size="small" @click="qx">取 消</el-button>
        </div>
      </el-dialog>

      <el-select
        v-if="searchCondition.status === 'goods'"
        size="small"
        clearable
        placeholder="选择品牌"
        v-model="searchCondition.brandNameList"
        class="mr10"
        filterable
        multiple
      >
        <el-option
          v-for="(item, i) in allBrankList"
          :key="i"
          :label="item.brandName"
          :value="item.brandName"
        ></el-option>
      </el-select>
      <el-input
        v-if="searchCondition.status === 'goods'"
        clearable
        v-model.trim="searchCondition.goodsKeyWords"
        placeholder="请输入商品名/货号/条码"
        size="small"
        class="mr10"
        style="width: 200px"
      ></el-input>
      <el-input
        v-if="
          searchCondition.status === 'tiXian' ||
          searchCondition.status === 'daoGou' ||
          searchCondition.status === 'mingxi' ||
          searchCondition.status === 'storeShare'
        "
        clearable
        v-model.trim="searchCondition.keyWords"
        placeholder="请输入导购名称/手机号"
        size="small"
        style="width: 270px"
        class="mr10"
      ></el-input>
      <el-cascader
        class="mr10"
        :options="area"
        size="small"
        v-if="
          searchCondition.status === 'menDian' ||
          searchCondition.status === 'daoGou'
        "
        ref="citys"
        clearable
        placeholder="请选择省市区"
        v-model="searchCondition.citys"
        :props="propsCity"
      >
      </el-cascader>
      <el-select
        v-model="searchCondition.queryTimeType"
        size="small"
        style="width: 101px; margin-left: 4px"
        class="time-type"
        filterable
      >
        <el-option label="小票时间" value="receipts"></el-option>
        <el-option label="扣费时间" value="deduction"></el-option>
      </el-select>
      <el-date-picker
        :default-time="['00:00:00', '23:59:59']"
        class="mr10 time"
        size="small"
        value-format="yyyy-MM-dd HH:mm:ss"
        v-model="searchCondition.receiptDate"
        type="datetimerange"
        range-separator="至"
        start-placeholder="选择小票时间时间段"
        end-placeholder="选择小票时间时间段"
      ></el-date-picker>
      <el-select
        v-if="searchCondition.status === 'daoGou'"
        size="small"
        clearable
        placeholder="选择门店"
        v-model="searchCondition.shopIds"
        class="mr10"
        filterable
        multiple
        style="width: 200px"
      >
        <el-option
          v-for="(item, i) in redpackageOutletRelList"
          :key="i"
          :label="item.shopName"
          :value="item.shopId"
        ></el-option>
      </el-select>
      <div class="flex item-center mr10 pointer ml10" @click="drawer = true">
        <div class="more-search">更多筛选</div>
        <div>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button
        type="success"
        size="small"
        @click="output"
        :loading="isOutputing"
        >导出</el-button
      >
      <el-button type="primary" size="small" @click="searchEs"
        >Es查询</el-button
      >
      <!-- <el-button type="primary" size="small" @click="searchMysql">查询Mysql</el-button> -->
      <el-button
        type="success"
        size="small"
        @click="output1"
        :loading="isOutputing"
        >Es导出</el-button
      >
    </div>
    <hm-content title="" ref="hmcontent">
      <div class="table" v-show="searchCondition.status === 'goods'">
        <el-table
          :data="goodsReportList.records"
          style="width: 100%"
          ref="goods"
          stripe
          border
          size="small"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="(index) => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            label="申报单号"
            prop="declareSn"
            column-key="declareSn"
          >
            <template slot-scope="scope">
              <div
                class="blue pointer"
                @click="viewDetails(scope.row.declareSn)"
              >
                {{ scope.row.declareSn }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="小票日期"
            prop="receiptTime"
            column-key="receiptTime"
          >
            <template slot-scope="scope">
              {{ scope.row.receiptTime }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="小票时间"
            prop="receiptDateStr"
            column-key="receiptDateStr"
          >
            <template slot-scope="scope">
              {{ scope.row.receiptDateStr }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="申报时间"
            prop="declareTime"
            column-key="declareTime"
          >
            <template slot-scope="scope">
              {{ scope.row.declareTime }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="所在省/市/区"
            prop="citys"
            column-key="citys"
          >
            <template slot-scope="scope">
              <span
                >{{ scope.row.provinceName }}{{ scope.row.cityName
                }}{{ scope.row.districtName }}</span
              >
            </template>
          </el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            prop="storeName"
            label="商户"
            column-key="storeName"
          >
            <template slot-scope="scope">
              {{ scope.row.storeName }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shopName"
            label="门店"
            column-key="shopName"
          >
            <template slot-scope="scope">
              {{ scope.row.shopName }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="guiderName"
            label="导购姓名"
            column-key="guiderName"
          >
            <template slot-scope="scope">
              {{ scope.row.guiderName }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="guiderPhone"
            label="手机号"
            column-key="guiderPhone"
          >
            <template slot-scope="scope">
              {{ scope.row.guiderPhone }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandNames"
            label="商品品牌"
            column-key="brandNames"
          >
            <template slot-scope="scope">
              {{ scope.row.brandNames }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsNames"
            label="商品"
            column-key="goodsNames"
          >
            <template slot-scope="scope">
              {{ scope.row.goodsNames }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsBarcodes"
            label="商品条码"
            column-key="goodsBarcodes"
          >
            <template slot-scope="scope">
              {{ scope.row.goodsBarcodes }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsNumSum"
            label="销售数量"
            column-key="goodsNumSum"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="小票"
            prop="receiptSn"
            column-key="ireceiptSn"
          >
            <template slot-scope="scope">
              {{ scope.row.receiptSn }}
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="goodsReportList.total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total,sizes,  prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
      <div class="table" v-show="searchCondition.status === 'tiXian'">
        <el-table
          :data="commissionReportList.records"
          style="width: 100%"
          ref="tixian"
          stripe
          border
          size="small"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="(index) => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="申报单号"
            prop="declareSn"
            column-key="declareSn"
          >
            <template slot-scope="scope">
              <div
                class="blue pointer"
                @click="viewDetails(scope.row.declareSn)"
              >
                {{ scope.row.declareSn }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="小票日期"
            prop="receiptTime"
            column-key="receiptTime"
          >
            <template slot-scope="scope">
              {{ scope.row.receiptTime }}
            </template>
          </el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            label="小票时间"
            prop="receiptDateStr"
            column-key="receiptDateStr"
          >
            <template slot-scope="scope">
              {{ scope.row.receiptDateStr }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="申报时间"
            prop="declareTime"
            column-key="declareTime"
          >
            <template slot-scope="scope">
              {{ scope.row.declareTime }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="所在省/市/区"
            prop="citys"
            width="110"
            column-key="citys"
          >
            <template slot-scope="scope">
              <span
                >{{ scope.row.provinceName }}{{ scope.row.cityName
                }}{{ scope.row.districtName }}</span
              >
            </template>
          </el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            prop="storeName"
            label="商户"
            width="120"
            column-key="storeName"
          >
            <template slot-scope="scope">
              {{ scope.row.storeName }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shopName"
            label="门店"
            column-key="shopName"
          >
            <template slot-scope="scope">
              {{ scope.row.shopName }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="guiderName"
            label="导购姓名"
            column-key="guiderName"
          >
            <!-- <template slot-scope="scope">
            {{ scope.row.guiderName }}
          </template> -->
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="guiderPhone"
            label="手机号"
            column-key="guiderPhone"
          >
            <template slot-scope="scope">
              {{ scope.row.guiderPhone }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandNames"
            label="商品品牌"
            column-key="brandNames"
          >
            <template slot-scope="scope">
              {{ scope.row.brandNames }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsNames"
            width="200"
            label="商品"
            column-key="goodsNames"
          >
            <template slot-scope="scope">
              {{ scope.row.goodsNames }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsBarcodes"
            label="商品条码"
            width="130"
            column-key="goodsBarcodes"
          >
            <template slot-scope="scope">
              {{ scope.row.goodsBarcodes }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsNumSum"
            label="销售数量"
            column-key="goodsNumSum"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="redpackageMoneySum"
            label="提成金额"
            column-key="redpackageMoneySum"
          >
            <template slot-scope="scope">
              <span class="primary">￥{{ scope.row.redpackageMoneySum }}</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="feeMoney"
            label="平台服务费"
            column-key="feeMoney"
          >
            <template slot-scope="scope">
              <span class="primary">￥{{ scope.row.feeMoney }}</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="afterBalance"
            label="账户余额"
          >
            <template slot-scope="scope">
              <div class="primary">¥{{ scope.row.afterBalance }}</div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="tradeTime"
            label="扣费时间"
            column-key="tradeTime"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="小票"
            prop="receiptSn"
            column-key="receiptSn"
          >
            <template slot-scope="scope">
              {{ scope.row.receiptSn }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="declareImg"
            label="小票照片"
            column-key="declareImg"
          >
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-image
                  style="width: 100px; height: 100px"
                  :src="scope.row.declareImgList[0]"
                  :preview-src-list="scope.row.declareImgList"
                ></el-image>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="commissionReportList.total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total,sizes,  prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
      <div class="table" v-show="searchCondition.status === 'menDian'">
        <el-table
          :data="shopReportList.records"
          style="width: 100%"
          ref="mendian"
          stripe
          border
          size="small"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="(index) => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            label="所在省/市/区"
            prop="citys"
            column-key="citys"
          >
            <template slot-scope="scope">
              <span
                >{{ scope.row.provinceName }}{{ scope.row.cityName
                }}{{ scope.row.districtName }}</span
              >
            </template>
          </el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            prop="storeName"
            label="商户"
            column-key="storeName"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shopName"
            label="门店"
            column-key="shopName"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsNumSum"
            label="销售数量"
            column-key="goodsNumSum"
          >
            <template slot-scope="scope">
              {{ scope.row.goodsNumSum }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shopPercent"
            label="单店红包占比"
            column-key="shopPercent"
          >
            <template slot-scope="scope">
              {{ scope.row.shopPercent }}%
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="redpackageMoneyCount"
            label="申报单数"
            column-key="redpackageMoneyCount"
          >
            <template slot-scope="scope">
              {{ scope.row.redpackageMoneyCount }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="redpackageMoneySum"
            label="发放金额"
            column-key="redpackageMoneySum"
          >
            <template slot-scope="scope">
              <span class="primary">￥{{ scope.row.redpackageMoneySum }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
          header-align="center"
          align="center"
          prop="percentageMoneys"
          label="平台服务费"
          column-key="percentageMoneys"
        >
          <template slot-scope="scope">
            <span class="primary">￥{{ scope.row.percentageMoneys }}</span>
          </template>
        </el-table-column> -->
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="shopReportList.total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total,sizes,  prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
      <div class="table" v-show="searchCondition.status === 'daoGou'">
        <el-table
          :data="guiderReportList.records"
          style="width: 100%"
          ref="daogou"
          stripe
          border
          size="small"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="(index) => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            label="所在省/市/区"
            prop="citys"
            column-key="citys"
          >
            <template slot-scope="scope">
              <span
                >{{ scope.row.provinceName }}{{ scope.row.cityName
                }}{{ scope.row.districtName }}</span
              >
            </template>
          </el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            prop="storeName"
            label="商户"
            column-key="storeName"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shopName"
            label="门店"
            column-key="shopName"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="guiderName"
            label="导购名称"
            column-key="guiderName"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="guiderPhone"
            label="导购电话"
            column-key="guiderPhone"
          ></el-table-column>
          <!-- <el-table-column
          header-align="center"
          align="center"
          prop="receiptCount"
          label="销量申报数"
          column-key="receiptCount"
        ></el-table-column> -->
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsNumSum"
            label="销售数量"
            column-key="goodsNumSum"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="receiptCount"
            label="申报单数"
            column-key="receiptCount"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="redpackageMoneySum"
            label="发放金额"
            column-key="redpackageMoneySum"
          >
            <template slot-scope="scope">
              <span class="primary">￥{{ scope.row.redpackageMoneySum }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
          header-align="center"
          align="center"
          prop="percentageMoneys"
          label="平台服务费"
          column-key="percentageMoneys"
        >
          <template slot-scope="scope">
            <span class="primary">￥{{ scope.row.percentageMoneys }}</span>
          </template>
        </el-table-column> -->
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="guiderReportList.total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total,sizes,  prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
      <div class="table" v-show="searchCondition.status === 'mingxi'">
        <el-table
          :data="reportListGroup"
          style="width: 100%"
          ref="mingxi"
          stripe
          border
          size="small"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="(index) => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="申报单号"
            prop="declareSn"
            column-key="declareSn"
          >
            <template slot-scope="scope">
              <div
                class="blue pointer"
                @click="viewDetails(scope.row.declareSn)"
              >
                {{ scope.row.declareSn }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="小票日期"
            prop="receiptTime"
            column-key="receiptTime"
          >
            <template slot-scope="scope">
              {{ scope.row.receiptTime }}
            </template>
          </el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            label="小票时间"
            prop="receiptDateStr"
            column-key="receiptDateStr"
          >
            <template slot-scope="scope">
              {{ scope.row.receiptDateStr }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="tradeTime"
            label="扣费时间"
            column-key="tradeTime"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="申报时间"
            prop="declareTime"
            column-key="declareTime"
          >
            <template slot-scope="scope">
              {{ scope.row.declareTime }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="所在省/市/区"
            prop="citys"
            column-key="citys"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span
                >{{ scope.row.provinceName }}{{ scope.row.cityName
                }}{{ scope.row.districtName }}</span
              >
            </template>
          </el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            prop="storeName"
            label="商户"
            column-key="storeName"
          >
            <template slot-scope="scope">
              {{ scope.row.storeName }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shopName"
            label="门店"
            column-key="shopName"
          >
            <template slot-scope="scope">
              {{ scope.row.shopName }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="guiderName"
            label="导购姓名"
            column-key="guiderName"
          >
            <!-- <template slot-scope="scope">
            {{ scope.row.guiderName }}
          </template> -->
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="guiderPhone"
            label="手机号"
            column-key="guiderPhone"
          >
            <template slot-scope="scope">
              {{ scope.row.guiderPhone }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandNames"
            label="商品品牌"
            column-key="brandNames"
          >
            <template slot-scope="scope">
              {{ scope.row.brandNames }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsNames"
            label="商品"
            column-key="goodsNames"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.goodsNames }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsBarcodes"
            label="商品条码"
            column-key="goodsBarcodes"
          >
            <template slot-scope="scope">
              {{ scope.row.goodsBarcodes }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsNumSum"
            label="销售数量"
            column-key="goodsNumSum"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="redpackageMoneySum"
            label="提成金额"
            column-key="redpackageMoneySum"
          >
            <template slot-scope="scope">
              <span class="primary">￥{{ scope.row.redpackageMoneySum }}</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="percentFeeMoney"
            label="服务费"
            column-key="percentFeeMoney"
          >
            <template slot-scope="scope">
              <span class="primary">￥{{ scope.row.percentFeeMoney }}</span>
            </template>
          </el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            label="小票"
            prop="receiptSn"
            column-key="receiptSn"
          >
            <template slot-scope="scope">
              {{ scope.row.receiptSn }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="declareImg"
            label="小票照片"
            column-key="declareImg"
          >
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-image
                  style="width: 100px; height: 100px"
                  :src="scope.row.declareImgList[0]"
                  :preview-src-list="scope.row.declareImgList"
                ></el-image>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="reportListGroupTotal"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total,sizes,  prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
      <div class="table" v-show="searchCondition.status === 'storeShare'">
        <el-table
          :data="storeShareList"
          style="width: 100%"
          ref="storeshare"
          stripe
          border
          size="small"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="(index) => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="申报单号"
            prop="declareSn"
            column-key="declareSn"
          >
            <template slot-scope="scope">
              <div
                class="blue pointer"
                @click="viewDetails(scope.row.declareSn)"
              >
                {{ scope.row.declareSn }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="小票日期"
            prop="receiptTime"
            column-key="receiptTime"
          >
            <template slot-scope="scope">
              {{ scope.row.receiptTime }}
            </template>
          </el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            label="小票时间"
            prop="receiptDateStr"
            column-key="receiptDateStr"
          >
            <template slot-scope="scope">
              {{ scope.row.receiptDateStr }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shareTradetime"
            label="扣费时间"
            column-key="shareTradetime"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="申报时间"
            prop="declareTime"
            column-key="declareTime"
          >
            <template slot-scope="scope">
              {{ scope.row.declareTime }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="所在省/市/区"
            prop="citys"
            column-key="citys"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span
                >{{ scope.row.provinceName }}{{ scope.row.cityName
                }}{{ scope.row.districtName }}</span
              >
            </template>
          </el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            prop="storeName"
            label="商户"
            column-key="storeName"
          >
            <template slot-scope="scope">
              {{ scope.row.storeName }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shopName"
            label="门店"
            column-key="shopName"
          >
            <template slot-scope="scope">
              {{ scope.row.shopName }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="guiderName"
            label="导购姓名"
            column-key="guiderName"
          >
            <!-- <template slot-scope="scope">
            {{ scope.row.guiderName }}
          </template> -->
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="guiderPhone"
            label="手机号"
            column-key="guiderPhone"
          >
            <template slot-scope="scope">
              {{ scope.row.guiderPhone }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="tradeMoney"
            label="分成金额"
            column-key="tradeMoney"
          >
            <template slot-scope="scope">
              <span class="primary">￥{{ scope.row.tradeMoney }}</span>
            </template>
          </el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            label="小票"
            prop="receiptSn"
            column-key="receiptSn"
          >
            <template slot-scope="scope">
              {{ scope.row.receiptSn }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="declareImg"
            label="小票照片"
            column-key="declareImg"
          >
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-image
                  style="width: 100px; height: 100px"
                  :src="scope.row.declareImgList[0]"
                  :preview-src-list="scope.row.declareImgList"
                ></el-image>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="storeShareListTotal"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total,sizes,  prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>

      <!-- <div class="table" v-if="searchCondition.status === 'daoGou'">
      <el-table
        :data="[]"
        style="width: 100%"
        ref="table"
        stripe
        border
        size="small"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="发放时段"
          prop="templateCode"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="所在省/市"
          prop="templateType"
        >
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="eventName"
          label="商户"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="eventName"
          label="门店"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="eventName"
          label="导购名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="eventName"
          label="导购电话"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="eventName"
          label="销量申报数"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="eventName"
          label="售卖商品数"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="eventName"
          label="发红包数"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="eventName"
          label="发放金额"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="eventName"
          label="平台服务费"
        >
        </el-table-column>
      </el-table>
    </div> -->
    </hm-content>
    <el-drawer
      title="更多筛选"
      :visible.sync="drawer"
      direction="rtl"
      size="730px"
    >
      <div class="drawer-search shop-list">
        <div class="flex flex-wrap">
          <el-cascader
            clearable
            class="mr10 mb10"
            ref="cascader"
            v-model="searchCondition.storeOrShopIds"
            :props="props"
            filterable
            :show-all-levels="false"
            size="small"
            placeholder="请选择商户"
          ></el-cascader>
          <el-select
            v-if="searchCondition.status === 'goods'"
            size="small"
            clearable
            placeholder="选择品牌"
            v-model="searchCondition.brandNameList"
            class="mr10 mb10"
            filterable
            multiple
          >
            <el-option
              v-for="(item, i) in allBrankList"
              :key="i"
              :label="item.brandName"
              :value="item.brandName"
            ></el-option>
          </el-select>
          <el-input
            v-if="searchCondition.status === 'goods'"
            clearable
            v-model.trim="searchCondition.goodsKeyWords"
            placeholder="请输入商品名/货号/条码"
            size="small"
            class="mr10 mb10"
            style="width: 200px"
          ></el-input>
          <el-input
            v-if="
              searchCondition.status === 'tiXian' ||
              searchCondition.status === 'daoGou' ||
              searchCondition.status === 'mingxi' ||
              searchCondition.status === 'storeShare'
            "
            clearable
            v-model.trim="searchCondition.keyWords"
            placeholder="请输入导购名称/手机号"
            size="small"
            style="width: 200px"
            class="mr10"
          ></el-input>
          <el-cascader
            class="mr10 mb10"
            :options="area"
            size="small"
            v-if="
              searchCondition.status === 'menDian' ||
              searchCondition.status === 'daoGou'
            "
            ref="citys"
            clearable
            placeholder="请选择省市区"
            v-model="searchCondition.citys"
            :props="propsCity"
          >
          </el-cascader>
          <el-select
            v-if="searchCondition.status === 'daoGou'"
            size="small"
            clearable
            placeholder="选择门店"
            v-model="searchCondition.shopIds"
            class="mr10 mb10"
            filterable
            multiple
            style="width: 200px"
          >
            <el-option
              v-for="(item, i) in redpackageOutletRelList"
              :key="i"
              :label="item.shopName"
              :value="item.shopId"
            ></el-option>
          </el-select>
        </div>

        <div class="mb10">
          <el-select
            v-model="searchCondition.queryTimeType"
            size="small"
            style="width: 101px; margin-left: 4px"
            class="time-type"
            filterable
          >
            <el-option label="小票时间" value="receipts"></el-option>
            <el-option label="扣费时间" value="deduction"></el-option>
          </el-select>
          <el-date-picker
            :default-time="['00:00:00', '23:59:59']"
            class="mr10 time"
            size="small"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="searchCondition.receiptDate"
            type="datetimerange"
            range-separator="至"
            start-placeholder="选择小票时间时间段"
            end-placeholder="选择小票时间时间段"
          ></el-date-picker>
        </div>

        <div class="flex flex-end">
          <el-button type="primary" size="small" @click="search"
            >查询</el-button
          >
          <el-button
            type="success"
            size="small"
            @click="output"
            :loading="isOutputing"
            >导出</el-button
          >
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getLoginUser, getUserName } from "@/utils/auth";
import area from "@/utils/area";
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      drawer: false,
      area,
      propsCity: {
        value: "value",
        children: "children",
      },
      props: {
        lazy: true,
        checkStrictly: true,
        multiple: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryStoreBasicInfoTree", {
                pageNo: 1,
                pageSize: 999,
                supplierCode: this.$route.query.storeCode,
              })
              .then((res) => {
                res.result.forEach((v) => {
                  v.leaf = Boolean(v.shopCount > 0 ? false : true);
                  v.value = v.storeCode;
                  v.label = v.storeName;
                });
                resolve(res.result);
              });
          } else if (level === 1) {
            this.$store
              .dispatch("queryStoreShopInfoTree", {
                storeCode: data.storeCode,
              })
              .then((res) => {
                if (res.code === "0" && res.result) {
                  res.result.forEach((v) => {
                    v.leaf = true;
                    v.value = v.shopId;
                    v.label = v.shopName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          } else {
            resolve([]);
          }
        },
      },
      searchCondition: {
        status: "tiXian",
        queryTimeType: "receipts",
        keyWords: "",
        receiptDate: [],
      },
      currentPage: 1,
      pageSize: 10,
      num: 0,
      storeNames: "",
      isOutputing: false,
      goodsReportList: {},
      reportListGroup: [],
      reportListGroupTotal: 0,
      allBrankList: [],
      redpackageOutletRelList: [],
      storeShareList: [],
      storeShareListTotal: 0,
      // 选择商户优化 2024-6-15
      storeVisible: false,
      storeCurrentPage: 1,
      storePageSize: 10,
      storesNames: "",
      storeCodeList: [],
      shopCurrentPage: 1,
      shopName: "",
      shopPageSize: 10,
      allOptions: [],
      selectedOptions: [],
      storeOrShopIds: [],
    };
  },
  computed: mapGetters([
    "commissionReportList",
    "shopReportList",
    "guiderReportList",
    "allCommissionReportList",
    // 2024-6-17
    "storeBasucList",
    "notRelShopList",
  ]),
  watch: {
    $route() {
      // const startTime = moment().startOf("day").format("YYYY-MM-DD HH:mm:ss");
      // const endTime = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
      // this.searchCondition.receiptDate = [startTime, endTime];
      // this.queryList();
      // this.queryAllList();
      // this.queryAllBrand();
      // this.queryRedpackageOutletRelList();
      // console.log(mapGetters)
      this.storeNames = localStorage.getItem("storeName");
      this.$store.dispatch("clearCommissionReportList");
      this.goodsReportList = {};
      this.storeShareList = {};
      this.reportListGroup = {};
    },
  },
  created() {},
  mounted() {
    // const startTime = moment(
    //   moment()
    //     .month(moment().month())
    //     .startOf("month")
    //     .valueOf()
    // ).format("YYYY-MM-DD HH:mm:ss");
    // const endTime = moment(
    //   moment()
    //     .month(moment().month())
    //     .endOf("month")
    //     .valueOf()
    // ).format("YYYY-MM-DD HH:mm:ss");
    const startTime = moment().startOf("day").format("YYYY-MM-DD HH:mm:ss");
    const endTime = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
    this.searchCondition.receiptDate = [startTime, endTime];
    // this.queryList();
    // this.queryAllList();
    this.queryAllBrand();
    this.queryRedpackageOutletRelList();
    this.storeNames = localStorage.getItem("storeName");
  },
  methods: {
    async queryStoreShareList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      const { result, code } = await this.$store.dispatch(
        "queryStoreShareManageList",
        params
      );
      if (code === "0") {
        const { records, total } = result;
        this.storeShareList = records;
        this.storeShareList.forEach((v) => {
          if (v.declareImg) {
            v.declareImgList = v.declareImg.split(",");
          } else {
            v.declareImgList = [""];
          }
        });
        console.log("storeShareList", this.storeShareList);
        this.storeShareListTotal = total;
      }
    },
    async queryRedpackageOutletRelList() {
      let params = {
        pageSize: 99999,
        pageNo: 1,
        storeCode: this.$route.query.storeCode,
      };
      const { code, result } = await this.$store.dispatch(
        "queryRedpackageOutletRelList",
        params
      );
      if (code === "0") {
        this.redpackageOutletRelList = result.records;
      }
    },
    async queryAllBrand() {
      const { result, code } = await this.$store.dispatch(
        "queryHemiaoBrandComboBox",
        {
          supplierCode: this.$route.query.storeCode,
        }
      );
      if (code === "0") {
        this.allBrankList = result;
      }
    },
    // "tiXian">申报明细</el-radio-button>
    //       <el-radio-button label="menDian">门店统计</el-radio-button>
    //       <el-radio-button label="daoGou
    switchTab(val) {
      this.searchCondition.keyWords = "";
      this.goodsReportList.records = [];
      this.goodsReportList.total = 0;

      this.commissionReportList.records = [];
      this.commissionReportList.total = 0;

      this.shopReportList.records = [];
      this.shopReportList.total = 0;

      this.guiderReportList.records = [];
      this.guiderReportList.total = 0;

      this.reportListGroup = [];
      this.reportListGroupTotal = 0;

      this.storeShareList = [];
      this.storeShareListTotal = 0;

      this.$nextTick(() => {
        let name = JSON.parse(JSON.stringify(val));
        this.$refs[name.toLowerCase()].doLayout();
        //给table加一个ref
      });
      if (
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
      ) {
        if (val === "tiXian") {
          this.currentPage = 1;
          this.pageSize = 10;
          this.checkedRow = [];
          this.queryList();
        } else if (val === "menDian") {
          this.currentPage = 1;
          this.pageSize = 10;
          this.queryShopList();
        } else if (val === "daoGou") {
          this.currentPage = 1;
          this.pageSize = 10;
          this.queryGuiderList();
        } else if (val === "goods") {
          this.currentPage = 1;
          this.pageSize = 10;
          this.queryGoodsList();
        } else if (val === "mingxi") {
          this.currentPage = 1;
          this.pageSize = 10;
          this.checkedRow = [];
          this.queryReportListGroup();
        } else if (val == "storeShare") {
          this.currentPage = 1;
          this.pageSize = 10;
          this.queryStoreShareList();
        }
      } else {
        this.$message({
          message: "请选择小票时间段!",
          type: "warning",
        });
      }
    },
    searchEs() {
      if (
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
      ) {
        if (this.searchCondition.status === "tiXian") {
          this.currentPage = 1;
          // this.queryListEs();
          this.queryListnewEs();
        } else if (this.searchCondition.status === "menDian") {
          this.currentPage = 1;
          this.queryShopList();
        } else if (this.searchCondition.status === "daoGou") {
          this.currentPage = 1;
          this.queryGuiderList();
        } else if (this.searchCondition.status === "goods") {
          this.currentPage = 1;
          this.obtainDeclareGoodsDetailsEs();
        } else if (this.searchCondition.status === "mingxi") {
          this.currentPage = 1;
          this.queryReportListGroup1();
        } else if (this.searchCondition.status === "storeShare") {
          this.currentPage = 1;
          this.queryStoreShareList();
        }
      } else {
        this.$message({
          message: "请选择时间段!",
          type: "warning",
        });
      }
    },
    searchMysql() {
      if (
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
      ) {
        if (this.searchCondition.status === "tiXian") {
          this.currentPage = 1;
          this.queryListMysql();
        } else if (this.searchCondition.status === "menDian") {
          this.currentPage = 1;
          this.queryShopList();
        } else if (this.searchCondition.status === "daoGou") {
          this.currentPage = 1;
          this.queryGuiderList();
        } else if (this.searchCondition.status === "goods") {
          this.currentPage = 1;
          this.queryGoodsList();
        } else if (this.searchCondition.status === "mingxi") {
          this.currentPage = 1;
          this.queryReportListGroup1();
        } else if (this.searchCondition.status === "storeShare") {
          this.currentPage = 1;
          this.queryStoreShareList();
        }
      } else {
        this.$message({
          message: "请选择时间段!",
          type: "warning",
        });
      }
    },
    search() {
      if (
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
      ) {
        if (this.searchCondition.status === "tiXian") {
          this.currentPage = 1;
          this.queryList();
        } else if (this.searchCondition.status === "menDian") {
          this.currentPage = 1;
          this.queryShopList();
        } else if (this.searchCondition.status === "daoGou") {
          this.currentPage = 1;
          this.queryGuiderList();
        } else if (this.searchCondition.status === "goods") {
          this.currentPage = 1;
          this.queryGoodsList();
        } else if (this.searchCondition.status === "mingxi") {
          this.currentPage = 1;
          this.queryReportListGroup();
        } else if (this.searchCondition.status === "storeShare") {
          this.currentPage = 1;
          this.queryStoreShareList();
        }
      } else {
        this.$message({
          message: "请选择时间段!",
          type: "warning",
        });
      }
    },
    paging(page) {
      this.currentPage = page;
      if (this.searchCondition.status === "tiXian") {
        this.queryList();
      } else if (this.searchCondition.status === "menDian") {
        this.queryShopList();
      } else if (this.searchCondition.status === "daoGou") {
        this.queryGuiderList();
      } else if (this.searchCondition.status === "goods") {
        this.queryGoodsList();
      } else if (this.searchCondition.status === "mingxi") {
        this.queryReportListGroup();
      } else if (this.searchCondition.status === "storeShare") {
        this.queryStoreShareList();
      }

      // this.queryList();
    },
    queryTime(searchCondition) {
      if (this.searchCondition.queryTimeType === "deduction") {
        searchCondition.tradeTimeStart =
          this.searchCondition.receiptDate &&
          this.searchCondition.receiptDate.length > 0
            ? this.searchCondition.receiptDate[0]
            : "";
        searchCondition.tradeTimeEnd =
          this.searchCondition.receiptDate &&
          this.searchCondition.receiptDate.length > 0
            ? this.searchCondition.receiptDate[1]
            : "";
        searchCondition.receiptStartDate = "";
        searchCondition.receiptEndDate = "";
        return searchCondition;
      } else {
        searchCondition.receiptStartDate =
          this.searchCondition.receiptDate &&
          this.searchCondition.receiptDate.length > 0
            ? this.searchCondition.receiptDate[0]
            : "";
        searchCondition.receiptEndDate =
          this.searchCondition.receiptDate &&
          this.searchCondition.receiptDate.length > 0
            ? this.searchCondition.receiptDate[1]
            : "";
        searchCondition.tradeTimeStart = "";
        searchCondition.tradeTimeEnd = "";
        return searchCondition;
      }
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      if (this.searchCondition.status === "tiXian") {
        this.queryList();
      } else if (this.searchCondition.status === "menDian") {
        this.queryShopList();
      } else if (this.searchCondition.status === "daoGou") {
        this.queryGuiderList();
      } else if (this.searchCondition.status === "goods") {
        this.queryGoodsList();
      } else if (this.searchCondition.status === "mingxi") {
        this.queryReportListGroup();
      } else if (this.searchCondition.status === "storeShare") {
        this.queryStoreShareList();
      }
    },
    async queryReportListGroup() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "findCommissionReportListGroupByReward",
        params
      );
      if (code === "0") {
        const { records, total } = result;
        this.reportListGroup = records;
        this.reportListGroupTotal = total;
      }
    },
    queryListEs() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      return this.$store.dispatch("obtainDeclareBillDetailsEs", params);
    },
    queryListnewEs() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      return this.$store.dispatch("newobtainDeclareBillDetailsEs", params);
    },
    queryListMysql() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      return this.$store.dispatch("obtainDeclareBillDetailsMysql", params);
    },
    queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryCommissionReportList", params);
    },
    async queryGoodsList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryGoodsReportList",
        params
      );
      this.goodsReportList = result;
    },

    async obtainDeclareGoodsDetailsEs() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "obtainDeclareGoodsDetailsEs",
        params
      );
      this.goodsReportList = result;
    },
    queryShopList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      if (typeof searchCondition.citys === "object") {
        searchCondition.shopProvinceCode = searchCondition.citys[0];
        searchCondition.shopCityCode = searchCondition.citys[1];
        searchCondition.shopDistrictCode = searchCondition.citys[2];
      }
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryShopReportList", params);
    },
    queryGuiderList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      if (typeof searchCondition.citys === "object") {
        searchCondition.shopProvinceCode = searchCondition.citys[0];
        searchCondition.shopCityCode = searchCondition.citys[1];
        searchCondition.shopDistrictCode = searchCondition.citys[2];
      }
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryGuiderReportList", params);
    },
    async queryAllGoodsList() {
      let params = {
        pageNo: 1,
        pageSize: 999999,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryAllGoodsReportList",
        params
      );
      return result;
    },
    queryAllList() {
      let params = {
        pageNo: 1,
        pageSize: 999999,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryAllCommissionReportList", params);
    },
    async queryAllReportListGroup() {
      let params = {
        pageNo: 1,
        pageSize: 999999,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "findAllCommissionReportListGroupByReward",
        params
      );
      if (code === "0") {
        const { records } = result;
        return records;
      }
    },
    queryAllShopList() {
      let params = {
        pageNo: 1,
        pageSize: 999999,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      if (typeof searchCondition.citys === "object") {
        searchCondition.shopProvinceCode = searchCondition.citys[0];
        searchCondition.shopCityCode = searchCondition.citys[1];
        searchCondition.shopDistrictCode = searchCondition.citys[2];
      }
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryAllShopReportList", params);
    },
    queryAllGuiderList() {
      let params = {
        pageNo: 1,
        pageSize: 999999,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      if (typeof searchCondition.citys === "object") {
        searchCondition.shopProvinceCode = searchCondition.citys[0];
        searchCondition.shopCityCode = searchCondition.citys[1];
        searchCondition.shopDistrictCode = searchCondition.citys[2];
      }
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryAllGuiderReportList", params);
    },
    viewDetails(declareSn) {
      let routeData = this.$router.resolve({
        name: "DetailsSalesVolumeNew",
        query: { declareSn },
      });
      window.open(routeData.href, "_blank");
    },

    // 导出excel
    async output1() {
      let params = {
        supplierCode: this.$route.query.storeCode,
        operUsername: getUserName(),
        supplierName: localStorage.getItem("storeName") || this.storeNames,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      if (this.searchCondition.status === "goods") {
        await this.$store.dispatch("exportDeclareGoodsDetailsEs", params);
      } else if (this.searchCondition.status === "tiXian") {
        // await this.$store.dispatch("exportDeclareBillDetailsEs", params);
        await this.$store.dispatch("newexportDeclareBillDetailsEs", params);
      } else if (this.searchCondition.status === "menDian") {
        await this.$store.dispatch("redpackageShopReportList", params);
      } else if (this.searchCondition.status === "daoGou") {
        await this.$store.dispatch("redpackageGuiderReportList", params);
      } else if (this.searchCondition.status === "mingxi") {
        await this.$store.dispatch(
          "redpackageCommissionReportListGroupByReward",
          params
        );
      } else if (this.searchCondition.status === "storeShare") {
        await this.$store.dispatch("redpackageStoreShareListOutput", params);
      }
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success",
        });
        this.$refs.hmcontent.flag = false;
      }, 0);
    },
    // 导出excel
    async output() {
      let params = {
        supplierCode: this.$route.query.storeCode,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      if (this.searchCondition.status === "goods") {
        await this.$store.dispatch("redpackageGoodsReportList", params);
      } else if (this.searchCondition.status === "tiXian") {
        await this.$store.dispatch("redpackageCommissionReportList", params);
      } else if (this.searchCondition.status === "menDian") {
        await this.$store.dispatch("redpackageShopReportList", params);
      } else if (this.searchCondition.status === "daoGou") {
        await this.$store.dispatch("redpackageGuiderReportList", params);
      } else if (this.searchCondition.status === "mingxi") {
        await this.$store.dispatch(
          "redpackageCommissionReportListGroupByReward",
          params
        );
      } else if (this.searchCondition.status === "storeShare") {
        await this.$store.dispatch("redpackageStoreShareListOutput", params);
      }
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success",
        });
        this.$refs.hmcontent.flag = false;
      }, 0);

      // let tradeTimeStart =
      //   this.searchCondition.applyDate &&
      //   this.searchCondition.applyDate.length > 0
      //     ? this.searchCondition.applyDate[0]
      //     : "全时段";
      // let tradeTimeEnd =
      //   this.searchCondition.applyDate &&
      //   this.searchCondition.applyDate.length > 0
      //     ? this.searchCondition.applyDate[1]
      //     : "全时段";
      // if (this.searchCondition.status === "tiXian") {
      //   require.ensure([], () => {
      //     const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
      //     this.isOutputing = true;

      //     this.queryAllList()
      //       .then(res => {
      //         let list = res.result.records;
      //         let tHeader = this.$refs.tixian.columns
      //           .map(o => o.label !== "序号" && o.label)
      //           .filter(o => o);

      //         let filterVal = [];
      //         if (list.length > 0) {
      //           filterVal = this.$refs.tixian.$children
      //             .map(o => o._props.prop)
      //             .filter(o => o);
      //         }

      //         let title = `${this.storeNames}_申报明细_${tradeTimeStart}-${tradeTimeEnd}`;

      //         let data = this.formatJson(filterVal, list);

      //         exportJsonToExcel(tHeader, data, title);
      //         this.isOutputing = false;
      //       })
      //       .catch(() => {
      //         this.isOutputing = false;
      //       });
      //   });
      // } else if (this.searchCondition.status === "menDian") {
      //   require.ensure([], () => {
      //     const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
      //     this.isOutputing = true;
      //     this.queryAllShopList()
      //       .then(res => {
      //         let list = res.result.records;

      //         list.forEach(v => {
      //           v.shopPercent = v.shopPercent + "%";
      //         });
      //         let tHeader = this.$refs.mendian.columns
      //           .map(o => o.label !== "序号" && o.label)
      //           .filter(o => o);
      //         let filterVal = [];
      //         if (list.length > 0) {
      //           filterVal = this.$refs.mendian.$children
      //             .map(o => o._props.prop)
      //             .filter(o => o);
      //         }

      //         let title = `${this.storeNames}_门店统计_${tradeTimeStart}-${tradeTimeEnd}`;
      //         let data = this.formatJson(filterVal, list);
      //         exportJsonToExcel(tHeader, data, title);
      //         this.isOutputing = false;
      //       })
      //       .catch(() => {
      //         this.isOutputing = false;
      //       });
      //   });
      // } else if (this.searchCondition.status === "daoGou") {
      //   require.ensure([], () => {
      //     const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
      //     this.isOutputing = true;
      //     this.queryAllGuiderList()
      //       .then(res => {
      //         let list = res.result.records;
      //         let tHeader = this.$refs.daogou.columns
      //           .map(o => o.label !== "序号" && o.label)
      //           .filter(o => o);
      //         let filterVal = [];
      //         if (list.length > 0) {
      //           filterVal = this.$refs.daogou.$children
      //             .map(o => o._props.prop)
      //             .filter(o => o);
      //         }

      //         let title = `${this.storeNames}_导购统计_${tradeTimeStart}-${tradeTimeEnd}`;
      //         let data = this.formatJson(filterVal, list);
      //         exportJsonToExcel(tHeader, data, title);
      //         this.isOutputing = false;
      //       })
      //       .catch(() => {
      //         this.isOutputing = false;
      //       });
      //   });
      // } else if (this.searchCondition.status === "goods") {
      //   require.ensure([], () => {
      //     const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
      //     this.isOutputing = true;
      //     this.queryAllGoodsList()
      //       .then(res => {
      //         let list = res.records;

      //         list.forEach(v => {
      //           v.city = v.provinceName + v.cityName + v.districtName;
      //         });
      //         let tHeader = this.$refs.goods.columns
      //           .map(o => o.label !== "序号" && o.label)
      //           .filter(o => o);
      //         let filterVal = [];
      //         if (list.length > 0) {
      //           filterVal = this.$refs.goods.$children
      //             .map(o => o._props.prop)
      //             .filter(o => o);
      //         }

      //         let title = `${this.storeNames}_商品明细_${tradeTimeStart}-${tradeTimeEnd}`;
      //         let data = this.formatJson(filterVal, list);
      //         exportJsonToExcel(tHeader, data, title);
      //         this.isOutputing = false;
      //       })
      //       .catch(() => {
      //         this.isOutputing = false;
      //       });
      //   });
      // } else if (this.searchCondition.status === "mingxi") {
      //   require.ensure([], () => {
      //     const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
      //     this.isOutputing = true;

      //     this.queryAllReportListGroup()
      //       .then(res => {
      //         let list = res;

      //         let tHeader = this.$refs.mingxi.columns
      //           .map(o => o.label !== "序号" && o.label)
      //           .filter(o => o);

      //         let filterVal = [];
      //         if (list.length > 0) {
      //           filterVal = this.$refs.mingxi.$children
      //             .map(o => o._props.prop)
      //             .filter(o => o);
      //         }

      //         let title = `${this.storeNames}_品牌明细_${tradeTimeStart}-${tradeTimeEnd}`;

      //         let data = this.formatJson(filterVal, list);

      //         exportJsonToExcel(tHeader, data, title);
      //         this.isOutputing = false;
      //       })
      //       .catch(() => {
      //         this.isOutputing = false;
      //       });
      //   });
      // }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    // 2024-6-15 选择商户优化
    openVisible() {
      this.storeVisible = true;
      this.notRelShopList.records = [];
      this.notRelShopList.total = 0;
      this.shopCurrentPage = 1;
      this.storePageSize = 10;
      this.shopPageSize = 10;
      this.queryStoreList();
    },
    storePaging(page) {
      this.storeCurrentPage = page;
      this.queryStoreList();
    },
    storeHandleSizeChange(size) {
      this.storeCurrentPage = 1;
      this.storePageSize = size;
      this.queryStoreList();
    },
    storeSearch() {
      this.storeCurrentPage = 1;
      this.queryStoreList();
    },
    // 获取一级商户列表
    queryStoreList() {
      let params = {
        pageSize: this.storePageSize,
        pageNo: this.storeCurrentPage,
        storeName: this.storesNames,
        queryRewardFlag: "exclude",
        queryRewardNumStat: "exclude",
        queryShopStat: "include",
        queryTemplateStat: "exclude",
        queryRiskeStat: "exclude",
      };
      this.$store.dispatch("queryStoreBasicList", params);
    },
    searchShop() {
      this.canClick = false;
      if (this.storeCodeList.length) {
        this.shopCurrentPage = 1;
        this.importData = false;
        // console.log("1", this.searchShopList());
        this.searchShopList();
      } else {
        this.$message({
          message: "请选择商户",
          type: "warning",
        });
      }
    },
    shopSearch() {
      this.shopCurrentPage = 1;
      this.searchShopList();
    },
    shopPaging(page) {
      this.shopCurrentPage = page;
      this.searchShopList();
    },
    shopHandleSizeChange(size) {
      this.shopCurrentPage = 1;
      this.shopPageSize = size;
      this.searchShopList();
    },
    searchShopList() {
      console.log(44444);
      let params = {
        pageSize: this.shopPageSize,
        pageNo: this.shopCurrentPage,
        shopName: this.shopName,
        storeCodeList: this.storeCodeList,
        supplierCode: this.$route.query.storeCode,
      };
      this.$store.dispatch("queryFindRelShopList", params);
    },
    //左边表格表格选中
    tableSelect(row) {
      this.$refs.roleTable.toggleRowSelection(row);
    },
    handleSelectionChange(row) {
      this.storeCodeList = row.map((v) => v.storeCode);
    },
    rest() {
      setTimeout(() => {
        this.departIds = "";
        this.storeCode = "";
        // this.storeName = "";
        this.shopName = "";
        this.storesNames = "";
        this.storeBasucList.records = [];
        this.storeBasucList.total = 0;
        this.notRelShopList.records = [];
        this.notRelShopList.total = 0;
      }, 0);
    },
    qx() {
      this.storeVisible = false;
      this.rest();
    },
    rightTableSelect(row, column) {
      if (column.label != "对应组织机构") {
        this.$refs.rightData.toggleRowSelection(row);
      }
    },
    getShopChecked(selection) {
      this.checkedShopRow = selection;
    },
    deleteShops() {
      this.searchCondition.storeOrShopIds = [];
      this.selectedOptions = "";
      this.storesNames = "";
    },
    submitAllStore() {
      if (this.checkedShopRow <= 0) {
        this.$message({
          message: "请选择",
          type: "warning",
        });
      } else {
        let arrs = [],
          subArrs = [],
          storeOrShopIds = [];
        this.checkedShopRow.forEach((v, index) => {
          console.log(index);
          let items = {
            label: v.shopName,
            value: v.shopCode,
            disabled: true,
          };
          let itemList = [];
          itemList[0] = v.storeCode;
          itemList[1] = v.shopId;
          arrs.push(items);
          if (index == 0) {
            subArrs.push(items.label);
          }
          // subArrs.push(items.label);
          // if (index == 0) {
          //   subArrs = `${subArrs}${v.shopName}`;
          // } else {
          //   subArrs = `${subArrs}, ${v.shopName}`;
          // }
          storeOrShopIds.push(itemList);
          if (v.departIds && v.departIds.length > 0) {
            v.departId = v.departIds[v.departIds.length - 1];
          }
        });
        this.allOptions = arrs;
        this.selectedOptions = subArrs;
        this.storeVisible = false;
        this.searchCondition.storeOrShopIds = storeOrShopIds;
        console.log(
          this.checkedShopRow,
          "提交后的数组",
          this.allOptions,
          this.selectedOptions
        );
      }
    },
  },
};
</script>
<style lang="scss">
.time-type {
  .el-input__inner {
    border-right: 0;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    color: #909399;
    background-color: rgb(245, 247, 250);
  }
}
.time {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}
.more-search {
  width: 10px;
  margin-right: 6px;
  transform: scale(0.9);
  color: #aaaaaa;
  box-shadow: -2px 2px 4px 0px rgba(0, 0, 0, 0.06);
  padding-left: 6px;
}
.bgColor {
  background: #fff;
}
.table-panel {
  font-size: 12px;
  .line {
    color: #dcdfe6;
    margin: 0 5px;
  }
}
.drawer-search {
  padding: 32px;
}
.seach_checked {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
}
</style>
